<template>
  <div class="faltas-limite">
    <template v-if="limite">
      <div class="d-flex align-baseline justify-space-between">
        <div>
          <span class="text-subtitle-1 font-weight-bold">{{ faltas }}</span>
          <span class="text-caption grey--text text--darken-1">
            de {{ limite }} {{ limite === 1 ? "falta permitida" : "faltas permitidas" }}
          </span>
        </div>
        <span class="text-body-2 font-weight-bold" :class="corTexto">{{ percentualLegivel }}</span>
      </div>
      <v-progress-linear
        aria-hidden="true"
        :value="Math.min(percentual, 100)"
        :color="cor"
        height="6"
        rounded
        background-color="grey lighten-3"
        class="mt-1"
      />
      <span class="sr-only">{{ percentualLegivel }} do limite anual de faltas consumido</span>
    </template>
    <template v-else>
      <div>
        <span class="text-subtitle-1 font-weight-bold">{{ faltas }}</span>
        <span class="text-caption grey--text text--darken-1">
          {{ faltas === 1 ? "falta" : "faltas" }}
        </span>
      </div>
      <div class="text-caption warning--text text--darken-2">
        <v-icon x-small color="warning darken-2">mdi-alert-outline</v-icon>
        Turma sem carga horária cadastrada — limite e percentual não calculados
      </div>
    </template>
  </div>
</template>

<script>
import { CORES_RISCO } from "@/components/BuscaAtiva/EChipRiscoEvasao.vue";

export default {
  name: "EFaltasDoLimite",
  props: {
    faltas: { type: Number, default: 0 },
    limite: { type: Number, default: null },
    percentual: { type: Number, default: null },
  },
  computed: {
    cor() {
      if (this.percentual > 50) return CORES_RISCO.critico;
      if (this.percentual > 25) return CORES_RISCO.alto_risco;
      return CORES_RISCO.atencao;
    },
    corTexto() {
      if (this.percentual > 50) return "red--text text--darken-3";
      if (this.percentual > 25) return "orange--text text--darken-3";
      return "grey--text text--darken-2";
    },
    percentualLegivel() {
      if (this.percentual === null) return "- - -";
      return `${this.percentual.toString().replace(".", ",")}%`;
    },
  },
};
</script>

<style scoped>
.faltas-limite {
  min-width: 170px;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
}
</style>
